function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.222 2.168l2.946 2.771L.222 7.711a.71.71 0 00-.164.231.676.676 0 00.164.776c.07.066.154.119.245.155a.799.799 0 00.825-.155L4.778 5.44a.682.682 0 000-1.007L1.292 1.153a.798.798 0 00-1.07 0 .696.696 0 000 1.015z",
  fill: "#50A684"
});
function SvgToggle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgToggle2;